/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import {Helmet} from "react-helmet";
import HelpButton from "../HelpButton";
import WhatsNewButton from "../WhatsNewButton";
import ThemeToggle from "../ThemeToggle";
import UserMenu from "./UserMenu";
/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
        <title>DS Simulator Data Forge</title>

      </Helmet>    
      <Navbar className="custom-navbar navbar-expand-md navbar-toggleable-md">

        <div className="container-fluid">
          <a className="navbar-brand" href="#">
          <img tag={Link} to="/" className="logo-icon" alt="" src="/logo.svg" />
          
          </a>
          <ul class="navbar-nav">
            <li class="nav-item">
              <h5>
                <center>DS Simulator Data Forge</center>
              </h5>

            </li>            
          </ul>

          <div className="collapse navbar-collapse justify-content-end">
            {/* Before signing in only the sign-in button is shown */}
            {isAuthenticated ? (
              <>
                <ThemeToggle />
                &nbsp;&nbsp;&nbsp;
                <WhatsNewButton />
                &nbsp;&nbsp;&nbsp;
                <HelpButton />
                &nbsp;&nbsp;&nbsp;
                <UserMenu />
              </>
            ) : (
              <SignInButton />
            )}
          </div>          
        </div>        
      </Navbar>

      {props.children}
    </>
  );
};
